module.exports = __webpack_public_path__ + "static/sport/bgi-h5.1d0ca94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/bgi-h5.jpg
// module id = 1SK2
// module chunks = 0